import script from "./CommunityStars.vue?vue&type=script&setup=true&lang=js"
export * from "./CommunityStars.vue?vue&type=script&setup=true&lang=js"

import "./CommunityStars.vue?vue&type=style&index=0&id=5ed5c838&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5ed5c838"]])

export default __exports__